import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {validateEmpty} from '../../../global/custom-validate';
import {BsModalRef } from 'ngx-bootstrap/modal';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import {UploadFileComponent} from '../../ui/upload/uploadfile.component';
import {Subject} from 'rxjs';
import {VanBanPhapQuyService} from '../../../service/info/service-vanbanphapquy';
import {VanBanPhapQuyFile} from '../../../models/info/vanbanphapquyfile';
import {VanBanPhapQuyFileService} from '../../../service/info/service-vanbanphapquyfile';
import {DatePipe} from '@angular/common';
import {VanBanPhapQuy} from '../../../models/info/vanbanphapquy';
import {CommandUtil} from '../../../global/commandutil';
@Component({
  templateUrl: './detail.component.html'

})
export class DetailVBPQComponent implements OnInit, AfterViewInit {
  public language = language;
  public onClose: Subject<boolean>;
  public vanBanPhapQuyItem: VanBanPhapQuy = new VanBanPhapQuy();
  public vanBanPhapQuyFiles: VanBanPhapQuyFile[] = [];
  constructor( public vanBanPhapQuyService: VanBanPhapQuyService,
               public vanBanPhapQuyFileService: VanBanPhapQuyFileService,
               public _bsModalRef: BsModalRef,
               public commandUtil: CommandUtil,
               public datepipe: DatePipe

  ) {
  }
  ngAfterViewInit() {

  }
  ngOnInit(): void {
    this.onClose = new Subject();
  }

  public edit(id: number) {
    this.vanBanPhapQuyService.readById(id).pipe(first())
      .subscribe(x => this.vanBanPhapQuyItem = x );

    this.vanBanPhapQuyFileService.findAllByHoSoId(id).subscribe(
      x =>  this.vanBanPhapQuyFiles = x );
  }



  public onConfirm(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}

